import { render, staticRenderFns } from "./tmVisualBorder.vue?vue&type=template&id=3dc3fb9c&"
import script from "./tmVisualBorder.vue?vue&type=script&lang=js&"
export * from "./tmVisualBorder.vue?vue&type=script&lang=js&"
import style0 from "./tmVisualBorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports